import LiferayHelper from './liferay';

const liferay = new LiferayHelper();

export async function fetchFaqs({ name, categories, vacabularyName }) {
  const scopeGroupId = liferay.getScopeGroupId();
  const headers = await liferay.getHeaders();

  const body = {
    name,
    categories,
    vacabularyName
  };

  const response = await fetch(
    `/o/sclservices/get-scl-faqs/${scopeGroupId}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(body)
    }
  );

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to fetch FAQs: ${response.status} - ${text}`);
  }

  // Support either array or { data: [] } style responses
  const json = await response.json();
  if (Array.isArray(json)) {
    return json;
  }
  if (Array.isArray(json?.data)) {
    return json.data;
  }
  return [];
}

